import * as React from 'react';

import useModalAccessibility from '../../../../Shared/hooks/useModalAccessibility';

const PreviewModal = ({ closeModal, openStudentView }) => {
  const { modalRef } = useModalAccessibility(closeModal);

  return (
    <div>
      <div className="preview-modal-background" />
      <div
        aria-labelledby="preview-modal-title"
        aria-modal="true"
        className="preview-modal"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div className="preview-modal-header">
          <h2 id="preview-modal-title">You&apos;re about to preview Quill Lessons</h2>
          <p>Quill Lessons provides whole-class lessons that are led by the teacher. Select questions for your students and instantly see their responses.</p>
          <p>Each time you select a new question or project a student&apos;s answer, students instantly see it on their screens.</p>
        </div>
        <div className="preview-modal-buttons">
          <button className="quill-button outlined small green focus-on-light" onClick={openStudentView} type="button">Open Student View</button>
          <button className="quill-button contained small green focus-on-light" onClick={closeModal} type="button">Continue to Teacher View</button>
        </div>
      </div>
    </div>
  );
};

export default PreviewModal;
